import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-pagination-dpl',
  templateUrl: './paginierung-dpl.component.html',
  imports: []
})
export class PaginierungDplComponent {
  @Input() public anzahlTreffer!: number;
  @Input() public aktuelleSeite!: number;
  public anzahlSeiten = input.required<number>();
  @Input() public position!: string;
  @Input() public idSuffix!: string;
  @Output() public firstClicked = new EventEmitter();
  @Output() public prevClicked = new EventEmitter();
  @Output() public nextClicked = new EventEmitter();
  @Output() public lastClicked = new EventEmitter();
  @Output() public threePagesNextClicked = new EventEmitter();
  @Output() public threePagesPreviousClicked = new EventEmitter();

  public pageFirstClicked(event: any): void {
    event.preventDefault();
    this.firstClicked.emit();
  }

  public pagePrevClicked(event: any): void {
    event.preventDefault();
    this.prevClicked.emit();
    event.target.blur();
  }

  public pageNextClicked(event: any): void {
    event.preventDefault();
    this.nextClicked.emit();
    event.target.blur();
  }

  public pageLastClicked(event: any): void {
    event.preventDefault();
    this.lastClicked.emit();
  }

  public pageThreePagesNextClicked(event: any): void {
    event.preventDefault();
    this.threePagesNextClicked.emit();
    event.target.blur();
  }

  public pageThreePagesPreviousClicked(event: any): void {
    event.preventDefault();
    this.threePagesPreviousClicked.emit();
    event.target.blur();
  }

  public get isFirstPage(): boolean {
    return this.aktuelleSeite === 1;
  }

  public get isThreePagesPrevious(): boolean {
    return this.aktuelleSeite > 3;
  }
  public get isThreePagesNext(): boolean {
    return this.aktuelleSeite + 2 < this.anzahlSeiten();
  }

  public get isLastPage(): boolean {
    return this.aktuelleSeite === this.anzahlSeiten() || this.anzahlSeiten() === 0;
  }

  public get isSecondFirstPage(): boolean {
    return this.aktuelleSeite <= 2;
  }

  public get isSecondLastPage(): boolean {
    const vorletzteSeite = this.anzahlSeiten() - 1;
    return this.aktuelleSeite >= vorletzteSeite || this.anzahlSeiten() === 0;
  }

  public get isSecondPage(): boolean {
    return this.aktuelleSeite === 2 || this.anzahlSeiten() === 0;
  }

  public get labelVorherigeSeite(): string {
    return `Vorherige Seite (${this.aktuelleSeite - 1})`;
  }

  public get labelNaechsteSeite(): string {
    return `Nächste Seite (${this.aktuelleSeite + 1})`;
  }

  public get labelLetzteSeite(): string {
    return `Letzte Seite ${this.anzahlSeiten()}`;
  }
}
